var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalAlignTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15794_139186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 11H11.333V21H13.333V11H16.333L12.333 7L8.33301 11ZM4.33301 3V5H20.333V3H4.33301Z",
    fill: "#303238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15794_139186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalAlignTop);
export default __webpack_public_path__ + "static/media/vertical_align_top.a1887b5d281773b2d1622be4857d0909.svg";
export { ForwardRef as ReactComponent };